import { PaginatedResponse } from './paginated-response';

export class Report {
  fileId: string;
  id: string;
  name: string;
  organizationId: string;
  link: string;

  constructor() {
    this.name = '';
  }
}

export class PaginatedReportDTO extends PaginatedResponse {
  records: Report[];
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/report.ts